import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { ORDER_QUERY_KEY } from "@entities/order";
import { type Filters, getPendingOrders } from "./api";
import { PageOfPreorder } from "@api/structures/PageOfPreorder";
import { useAuthenticationContext } from "@app/auth/use-authentication-context";

export interface Options<F = Omit<Filters, "companyId">> extends Partial<
  UseQueryOptions<PageOfPreorder>
> {
  filters: F;
}

export const usePendingOrdersQuery = (options: Options) => {
  const { activeCompany } = useAuthenticationContext();

  return useQuery({
    enabled: !!activeCompany,
    /** The trailing element keeps this apart from `useOrdersQuery`, whose key has the same shape. */
    queryKey: [
      ORDER_QUERY_KEY,
      { companyId: activeCompany?.id, ...options?.filters },
      "pending",
    ],
    queryFn: () => getPendingOrders(options?.filters ?? {}),
    ...options,
  });
};
